import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SecretariaChatComponent } from './secretaria-chat/secretaria-chat.component';

const routes: Routes = [
  { path: '', component: SecretariaChatComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SecretariaRoutingModule {}
